import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import WhyWebcollPage from '../pages/why-webcoll/page';
import PackagesPage from '../pages/packages/page';
import BlogPage from '../pages/blog/page';
import BlogDetailPage from '../pages/blog/blog-detail/page';
import ContactPage from '../pages/contact/page';
import NotFound from '../pages/NotFound';

import AdminLayout from '../components/feature/AdminLayout';
import AdminLogin from '../pages/admin/login/page';
import AdminDashboard from '../pages/admin/dashboard/page';
import AdminApplications from '../pages/admin/applications/page';
import AdminCustomers from '../pages/admin/customers/page';
import AdminMessages from '../pages/admin/messages/page';
import AdminSettings from '../pages/admin/settings/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/neden-webcoll',
    element: <WhyWebcollPage />,
  },
  {
    path: '/paketler',
    element: <PackagesPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/:slug',
    element: <BlogDetailPage />,
  },
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },

  // Admin Routes
  {
    path: '/admin/login',
    element: <AdminLogin />
  },
  {
    path: '/admin',
    element: <AdminLayout><AdminDashboard /></AdminLayout>,
    children: [
      {
        path: 'dashboard',
        element: <AdminDashboard />
      },
      {
        path: 'applications',
        element: <AdminApplications />
      },
      {
        path: 'customers',
        element: <AdminCustomers />
      },
      {
        path: 'messages',
        element: <AdminMessages />
      },
      {
        path: 'settings',
        element: <AdminSettings />
      }
    ]
  }
];

export default routes;